import { render, staticRenderFns } from "./BaseListCell.vue?vue&type=template&id=b13cd07c&scoped=true&"
import script from "./BaseListCell.vue?vue&type=script&lang=ts&"
export * from "./BaseListCell.vue?vue&type=script&lang=ts&"
import style0 from "./BaseListCell.vue?vue&type=style&index=0&id=b13cd07c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13cd07c",
  null
  
)

export default component.exports